import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import PageHeading from "../components/page-heading"
import Button from "../components/button"
import Gallery from "../components/gallery"
import GradiLink from "../components/gradi-link.js"
import LocationInfo from "../components/location-info"
import { GatsbyImage } from "gatsby-plugin-image";
import LocationLinks from "../components/location-links"
import { normalizePath } from "../utils/get-url-path"
import { styleForType } from "../utils/gradi"
import Seo from 'gatsby-plugin-wpgraphql-seo';
import { gradiMeta } from '../utils/seo'

const NewsItem = ({ data, pageContext: { currentBrand, id }, location }) => {
  const {
    wpNewsItem,
  } = data
  const { uri, title, slug, news } = wpNewsItem

  const contents = news.content
    ? news.content.map(({ type, text }, i) => {
        return <div className={styleForType(type) + " news-content whitespace-pre-wrap"} dangerouslySetInnerHTML={{ __html: text }} />
      })
    : null

  const meta = gradiMeta({ seo: wpNewsItem.seo, location, currentBrand})
  return (
    <Layout currentBrand={currentBrand} location={location}>
      <Seo post={data.wpNewsItem} meta={meta} />
      <PageHeading>{title}</PageHeading>
      <div className="grid grid-cols-1 gap-5 md:gap-10 md:grid-cols-2">
        <div>
          <Gallery gallery={news.newsGallery} />
        </div>
        <div className="flex flex-col gap-10 justify-space-between">
          {contents}
          {news.buttonLink !== null ? (
            <Button banner className="self-center hover:text-warm-gray hover:bg-blackish" to={news.buttonLink.url}>
              {news.buttonLink.title}
            </Button>
          ) : (
            <></>
          )}
        </div>
      </div>
    </Layout>
  )
}
export default NewsItem

export const query = graphql`query newsQuery($id: String) {
  wpNewsItem(id: {eq: $id}) {
    uri
    title
    slug
    nodeType
    ...SeoFields
    news {
      heading
      brand
      content {
        text
        type
      }
      excerpt
      buttonLink {
        title
        url
      }
      newsGallery {
        localFile {
          childImageSharp {
            gatsbyImageData(aspectRatio: 1.5, layout: CONSTRAINED)
          }
        }
      }
    }
  }
}
`
